import './PageNotFound.css';
import { Link } from 'react-router-dom';
import logo from '../../images/logo.png';

function PageNotFound() {
  return (
    <div className="page-not-found">
      <div className="content">
        <Link to="/" className="back-button">Voltar</Link>
        <img src={logo} alt="LocaSmart Pro" className="logo" />
        <h1>404</h1>
        <h2>Página não encontrada</h2>
        <p>A página que você está procurando não existe ou foi removida.</p>
      </div>
    </div>
  );
}

export default PageNotFound;
